/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type TableQueryGuideInput = {
    detail_level?: TableQueryGuideInput.detail_level;
};

export namespace TableQueryGuideInput {

    export enum detail_level {
        COMPACT = 'compact',
        FULL = 'full',
    }


}

